import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Upload, Button, Select, Image } from 'antd'
import { UploadOutlined } from '@ant-design/icons';
import {withTranslation} from 'react-i18next'
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage'

@inject('intelligentOutboundCallModelStore')
@observer
class FormModal extends Component {
  state = {
    obsImageUrl: '',
    loading: false
  }

  formRef = React.createRef()
  
  getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      alertMessage.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      alertMessage.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)
    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`
    }
  }
  handleChange = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({loading: true});
      return;
    }
    if (info.file.status === 'done') {
      // 获取上传接口的返回值并存储到 obsImageUrl
      const response = info.file.response;
      if (response && response.data) {
        this.setState({
          obsImageUrl: JSON.stringify(response.data),
          loading: false
        });
      }
    } else if (info.file.status === 'error') {
      this.setState({loading: false});
    }
  }
  componentDidMount() {
  }

  handleOk = () => {
    const {intelligentOutboundCallModelStore, handleCancel, title} = this.props
    const {detailsObj} = intelligentOutboundCallModelStore
    const {obsImageUrl} = this.state
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? detailsObj?.id : null,
        "modelName": fieldsValue.modelName,
        "obsImageUrl": obsImageUrl,
        "dataId": fieldsValue.bindModel,
      }
      if (title === 'edit') {
        intelligentOutboundCallModelStore.onAddJobAction({...params, id: detailsObj.id}, title).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        intelligentOutboundCallModelStore.onAddJobAction({...params}).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(() => {})
  }
  render() {
    const {intelligentOutboundCallModelStore, addModalVisible, handleCancel, title, t } = this.props
    const {bindList} = intelligentOutboundCallModelStore
    const UPLOAD_TEMPLATE_URL = `${window.g.apiBaseUrl}/market/management/file/upload`
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`general.view`) + t(`menu.intelligentCallModel`) : t(`general.addData`) + t(`menu.intelligentCallModel`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={title === 'edit' ? [] : [
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addRemarkTemplate">
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Form.Item label={t(`outboundCall.modelName`)} name="modelName" rules={[{ required: true, message: t(`general.pleaseEnter`) }]}>
                  <Input placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="bindModel" label={t(`outboundCall.bindModel`)}
                  rules={[{required: true, message: t(`general.pleaseSelect`) }]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                    {bindList?.map(item => (<Select.Option key={item?.id} value={item?.id}>{item?.name}</Select.Option>))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="obsImageUrl"
                  label={t(`emailSend.attachmentUpload`)}
                  extra="允许常见图片类型上传 (*.jpg;*.png;*.gif;*.bmp;*.jpeg;) ，图片最大允许 1M。"
                  rules={[{ required: true, message: t(`general.pleaseUpload`) }]}
                >
                  <Upload
                    action={UPLOAD_TEMPLATE_URL}
                    listType="picture"
                    maxCount={1}
                    accept=".jpg,.png,.gif,.bmp,.jpeg"
                    name="file"
                    headers={this.getHeader()}
                    beforeUpload={this.beforeUpload}
                    onChange={this.handleChange}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
